import Icon from '@cobliteam/colib-ui/Icon';
import Typography from '@cobliteam/colib-ui/Typography';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { useTranslation } from '@cobliteam/i18n';
import { useLocation } from 'react-router-dom';

type MaintenancePageProps = {
  title: string;
  path: string;
};

type Maintenance = {
  url: string;
  time: number;
  reason?: string;
};

const MaintenancePage = ({ title }: MaintenancePageProps) => {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const featureFlags = useFeatureFlags();
  let maintenance: Maintenance | undefined;
  const { maintenance: maintenanceFlag } = featureFlags;

  // Check for array of objects
  if (Array.isArray(maintenanceFlag)) {
    maintenance = maintenanceFlag.find((flag) => flag && typeof flag === 'object' && 'url' in flag && flag.url === pathname);
  }

  // Make robust check for single object
  if (maintenanceFlag && typeof maintenanceFlag === 'object' && !Array.isArray(maintenanceFlag) && (maintenanceFlag as { url?: unknown }).url === pathname) {
    maintenance = maintenanceFlag as Maintenance;
  }

  return (
    <div className='flex h-full flex-col items-center justify-center gap-6 text-center'>
      <Icon name='wrench' size='4xl' className='box-content overflow-visible rounded-full bg-warning/10 p-10' />

      <div className='flex flex-col items-center justify-center text-center'>
        <Typography variant='headline' className='gap-1 break-words font-semibold text-foreground' render={(props) => <h1 {...props} />}>
          {t('pages.maintenance.title', { title })}
        </Typography>

        <Typography variant='body' className='mt-2 gap-1 break-words text-foreground text-muted-foreground'>
          {t('pages.maintenance.description')}
        </Typography>

        {maintenance?.reason && (
          <Typography variant='body' className='mt-4 gap-1 break-words text-foreground text-foreground'>
            Observação: {maintenance.reason}
          </Typography>
        )}
      </div>

      {maintenance?.time && (
        <div className='flex flex-col items-center gap-4'>
          <div className='flex items-center gap-2 text-warning'>
            <Icon name='clock' size='md' />
            Previsão de tempo:{' '}
            <Typography variant='body' className='gap-1 break-words text-foreground'>
              {(maintenance?.time ?? 0) / 60} minutos
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaintenancePage;
